import { Comuna } from './comuna';
import { CementProduct } from './cement-product';
import { Schedule } from './schedule';
import { User } from './user';

export const TIPO_ENTREGA_DESPACHO = 'despacho';
export const TIPO_ENTREGA_RETIRA_CLIENTE = 'retira_cliente';

export const TIPO_DESPACHO_A_PISO = 0;
export const TIPO_DESPACHO_SOBRE_CAMION = 1;

/** Máximo total de caracteres (3 segmentos SAP de 35). */
export const CEMENTO_DELIVERY_INSTRUCTIONS_MAX_LENGTH = 105;

/** Persona de contacto (SAP CAMPO5). */
export const CEMENTO_CONTACT_NAME_MAX_LENGTH = 50;

export type CementoSection =
  | 'producto'
  | 'tipoEntrega'
  | 'cantidadServicios'
  | 'fechaServicios'
  | 'facturacion';

export const CEMENTO_SECTIONS_ORDER: CementoSection[] = [
  'producto',
  'tipoEntrega',
  'cantidadServicios',
  'fechaServicios',
  'facturacion',
];

export interface CementoProductoSelection {
  product?: CementProduct;
}

export interface CementoMapaAddress {
  lat: number;
  lng: number;
  comuna: string;
  region: string;
  regionCode?: number;
  street: string;
  number: string;
  address: string;
}

export interface CementoAccessPoint {
  lat: number;
  lng: number;
  comuna: string;
  region: string;
  regionCode?: number;
  street: string;
  number: string;
  address: string;
}

export interface CementoMapaSelection {
  dispatchAddress: CementoMapaAddress;
  accessPoint: CementoAccessPoint;
  /**
   * True si el geocode de despacho incluyó número de calle (complementaria opcional en mapa).
   * Si el usuario no movió el pin, no se duplica la dirección de despacho en ``accessPoint`` guardado;
   * el payload de cotización/pago completa desde despacho cuando haga falta.
   */
  accessPointOptional?: boolean;
}

export type TipoEntrega = typeof TIPO_ENTREGA_DESPACHO | typeof TIPO_ENTREGA_RETIRA_CLIENTE;

export interface CementoTipoEntregaSelection {
  tipoEntrega?: TipoEntrega;
  tipoDespacho?: number;
  comuna?: Comuna;
  incoterm?: string;
}

export interface CementoCantidadServiciosSelection {
  pallets?: number;
  quantity?: number;
  leadHours?: number;
  unitPrice?: number;
  totalPrice?: number;
}

export interface CementoFechaServiciosSelection {
  schedule?: Schedule;
}

export interface CementoFacturacionSelection {
  billing?: Partial<User>;
  sameDispatchAddress?: boolean;
  acceptTerms?: boolean;
  contactName?: string;
  contactPhone?: string;
  deliveryInstructions?: string;
}

export interface CementoCheckoutState {
  orderBuy?: string;
  resumeToken?: string;
  mapa?: CementoMapaSelection;
  producto?: CementoProductoSelection;
  tipoEntrega?: CementoTipoEntregaSelection;
  cantidadServicios?: CementoCantidadServiciosSelection;
  fechaServicios?: CementoFechaServiciosSelection;
  facturacion?: CementoFacturacionSelection;
}
